var App = App || {};

App.Parallax = (function ($) {
    "use strict";

    function init() {
        $(".block.block-homepagebanner .block-background").ZagParallax({ divisor: 4 });
        $(".slip-opinion-page-masthead .block-background").ZagParallax({ divisor: 4 });
        $(".detail-masthead .block-background").ZagParallax({ divisor: 4 });
        $(".category-masthead .page-masthead-image").ZagParallax({ divisor: 7 });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Parallax.init();
});